class BitcoinConnectorError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "BitcoinConnectorError";
  }
}

export class BitcoinConnectorProviderNotFoundError extends BitcoinConnectorError {
  constructor(providerName: string) {
    super(`Bitcoin provider ${providerName} not found`);
  }
}

export class BitcoinConnectorTransactionFailedError extends BitcoinConnectorError {
  constructor() {
    super("Bitcoin transaction failed");
  }
}

export class BitcoinConnectorInvalidAccountError extends BitcoinConnectorError {
  constructor() {
    super("Bitcoin account is invalid");
  }
}
